import { Activity } from '../../../pure-js/types/GrooverTypes'

type ActivityQueryStatus = 'idle' | 'loading' | 'success' | 'error'

/**
 * True while an activity id has been requested but the Firestore query hasn't reported back yet.
 *
 * An id we haven't heard back about is not the same as "no such activity", and callers must not
 * treat it as one. `useFirestoreQuery` only dispatches 'loading' from an effect, so for one commit
 * after the id changes it still reports `isLoading === false` with no data. RegisterPage's render
 * gate used to fall through that window to <EmptyActivity />, whose illustration is a separate
 * multi-hundred-KB request — paid in full for a frame that is never meaningfully visible.
 */
export function isActivityQueryPending(
  activityId: string,
  activity: Activity | undefined,
  status: ActivityQueryStatus
): boolean {
  if (!activityId) return false
  if (activity) return false

  return status !== 'success' && status !== 'error'
}
